import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import URI from 'urijs';
import { getConfig } from '../../services/config';
import getInnerUrl from '../../services/get-inner-url';
import getOuterUrl from '../../services/get-outer-url';
import { push } from '../../services/router-utils';
import { isSeoViewMode } from '../../services/wix-sdk-utils';

const isModifiedEvent = event => !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

const InternalLink = ({ push, to, onClick, children, renderInSeo, fullUrl, sectionUrl, ...props }) => {
  const linkProps = omit(props, 'dispatch');

  const handleClick = event => {
    if (onClick) {
      onClick(event);
    }
    if (event.defaultPrevented) {
      return;
    }

    if (!isModifiedEvent(event)) {
      event.preventDefault();
      event.stopPropagation();
      push(fullUrl ? getInnerUrl(to, sectionUrl) : to);
    }
  };

  let location;
  if (fullUrl) {
    location = new URI(to);
  } else if (typeof to === 'object') {
    location = new URI(getOuterUrl(to.pathname, sectionUrl));
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new URI(getOuterUrl(to, sectionUrl));
  }

  if (isSeoViewMode() && !renderInSeo) {
    return (
      <div {...linkProps}>
        {children}
      </div>
    );
  }
  return (
    <a target="_top" href={location.toString()} onClick={handleClick} {...linkProps}>
      {children}
    </a>
  );
};

InternalLink.propTypes = {
  push: PropTypes.func,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  renderInSeo: PropTypes.bool,
  fullUrl: PropTypes.bool,
  sectionUrl: PropTypes.string,
};

InternalLink.defaultProps = {
  renderInSeo: true,
};

const mapStateToProps = (state, { sectionUrl }) => ({
  sectionUrl: sectionUrl || getConfig().sectionUrl,
});

const mapDispatchToProps = (dispatch, { push: pushFn }) => bindActionCreators({ push: pushFn || push }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalLink);



// WEBPACK FOOTER //
// ./app/components/link/internal-link.js